import { authService } from 'src/services/rider-portal/Auth'
import { actionCreators } from 'src/state/actions/rider-portal/main'
import { saveAuthTokens, saveRiderPortalCurrentUser } from 'src/utils/auth'
import { riderService } from 'src/services/Rider'
import { handleRedirect } from 'src/utils'
import {
  IAuthTokenDto,
  IGenerateOtpAndSendViaEmailDto,
  IGenerateOtpAndSendViaSmsDto,
  IRiderAuthDetails,
  IUserDeviceToken
} from 'src/types/rider-portal'
import { RIDER_PORTAL_USER_TYPE } from 'src/constants/rider-portal'

export const generateOtpAndSendViaEmail = (riderDetails: IRiderAuthDetails) => {
  return () => {
    return authService
      .generateOtpAndSendViaEmail(riderDetails)
      .then(({ errorStatus, success }: IGenerateOtpAndSendViaEmailDto) => {
        if (success) {
          return { success, message: 'We’ve successfully sent your one-time password to your registered email.' }
        } else {
          return { success: false, message: errorStatus }
        }
      })
      .catch(() => ({ success: false, message: 'An error occurred. Please try again later.' }))
  }
}

export const generateOtpAndSendViaSms = (riderDetails: IRiderAuthDetails) => {
  return () => {
    return authService
      .generateOtpAndSendViaSms(riderDetails)
      .then(({ hasError, message }: IGenerateOtpAndSendViaSmsDto) => {
        if (!hasError) {
          return {
            success: !hasError,
            message: 'We’ve successfully sent your one-time password to your registered phone number.'
          }
        } else {
          return { success: false, message }
        }
      })
      .catch(() => ({ success: false, message: 'An error occurred. Please try again later.' }))
  }
}

export const getCurrentUserInfo = (userId: string) => {
  return (dispatch: any) => {
    const { setLoadingMetadata, setLoggedInRiderDetails } = actionCreators
    dispatch(setLoadingMetadata('isLoading', true))
    return riderService
      .getRiderPersonalInfo(userId)
      .then(user => {
        const {
          countryCode = '',
          email = '',
          firstName = '',
          id = '',
          lastName = '',
          organizationId = '',
          phone = ''
        } = user
        if (id && organizationId) {
          dispatch(setLoggedInRiderDetails(user))
          saveRiderPortalCurrentUser({ countryCode, email, firstName, id, lastName, organizationId, phone })
          handleRedirect('/rider-portal/booking')
          console.log('Successfully fetch user details.')
        } else {
          console.log('An error occurred while fetching user details.')
        }
      })
      .catch(({ data }) => console.log(`Error fetching rider personal info: ${data}`))
      .finally(() => dispatch(setLoadingMetadata('isLoading', false)))
  }
}

export const updateDeviceToken = (deviceToken: IUserDeviceToken) => {
  return () => {
    return authService
      .updateDeviceToken(deviceToken)
      .then(({ message }) => console.log('Update Device Token: ', message))
      .catch(({ data }) => console.log('Update Device Token Error: ', data))
  }
}

export const verifyOtpCode = (riderDetails: IRiderAuthDetails) => {
  return () => {
    return authService
      .verifyOtpCode(riderDetails)
      .then(({ accessToken, refreshToken }: IAuthTokenDto) => {
        if (accessToken && refreshToken) {
          saveAuthTokens({ accessToken, refreshToken }, RIDER_PORTAL_USER_TYPE)

          return {
            success: true,
            message: 'Successfully logged in!'
          }
        } else {
          return { success: false, message: 'Invalid one-time password.' }
        }
      })
      .catch(({ data: message }) => ({ success: false, message }))
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/rider-portal/auth.tsx